export const privilegeTypeEnum = {
  GROUP: 'group',
  CARD: 'card',
};
